// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import i18n from "./i18n"; // 👈 导入 i18n 配置

const container = document.getElementById("root");

const startApp = () => {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// 等待 i18n 初始化完成后再挂载 React
if (i18n.isInitialized) {
  startApp();
} else {
  i18n.on("initialized", () => {
    startApp();
  });
}
